export default "__VITE_ASSET__Cuyu4tLR__"